<script>
import { HorizontalBar, mixins } from "vue-chartjs";
const { reactiveProp } = mixins;

export default {
  extends: HorizontalBar,
  mixins: [reactiveProp],
  props: ["options"],
  mounted() {
    let dataCollection = {
      labels: [],
      datasets: [
        {
          backgroundColor: "#38B2AC",
          pointBackgroundColor: "white",
          borderWidth: 1,
          pointBorderColor: "#249EBF",
          data: []
        }
      ]
    };
    Object.keys(this.chartData).forEach(key => {
      dataCollection.labels.push(key);
      dataCollection.datasets[0].data.push(this.chartData[key]);
    });
    this.renderChart(dataCollection, this.options);
  }
};
</script>
